import { gql } from '@apollo/client';

export const ORGANIZATION_FIELDS = gql`
  fragment OrganizationFields on Organization {
    addressId
    contactId
    uid
    name
    organizationId
    appEnvId
  }
`;
